(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["deferred-mux-player"] && !Shopify.designMode) return;
  try {
    (() => {
    const PLAYER_SELECTOR = '[data-deferred-mux-player]';
    const PLAYER_SOURCE = 'https://cdn.jsdelivr.net/npm/@mux/mux-player@3.10.1/+esm';
    const namespace = window.HarrogateOrganics || (window.HarrogateOrganics = {});
    const mux = namespace.mux || (namespace.mux = {});

    mux.loadPlayer = mux.loadPlayer || (() => {
      if (customElements.get('mux-player')) {
        return Promise.resolve();
      }

      if (!mux.playerPromise) {
        mux.playerPromise = import(PLAYER_SOURCE)
          .then(() => customElements.whenDefined('mux-player'))
          .catch((error) => {
            mux.playerPromise = null;
            throw error;
          });
      }

      return mux.playerPromise;
    });

    const setOptionalAttribute = (element, name, value) => {
      if (value) element.setAttribute(name, value);
    };

    const activatePlayer = async (wrapper, shouldPlay) => {
      if (!wrapper || wrapper.querySelector('mux-player')) return;

      if (shouldPlay) wrapper.setAttribute('data-play-requested', '');
      if (wrapper.hasAttribute('data-loading')) return;

      wrapper.setAttribute('data-loading', '');
      wrapper.removeAttribute('data-mux-error');

      try {
        await mux.loadPlayer();

        if (!wrapper.isConnected) return;

        const player = document.createElement('mux-player');
        player.setAttribute('playback-id', wrapper.dataset.playbackId);
        player.setAttribute('stream-type', 'on-demand');
        player.setAttribute('preload', 'none');
        player.setAttribute('controls', '');
        player.setAttribute('playsinline', '');
        setOptionalAttribute(player, 'poster', wrapper.dataset.poster);
        setOptionalAttribute(player, 'accent-color', wrapper.dataset.accentColor);
        setOptionalAttribute(player, 'metadata-video-id', wrapper.dataset.metadataVideoId);
        setOptionalAttribute(player, 'metadata-video-title', wrapper.dataset.metadataVideoTitle);

        wrapper.replaceChildren(player);
        mux.prefetchObserver?.unobserve(wrapper);
        mux.viewportObserver?.unobserve(wrapper);

        if (wrapper.hasAttribute('data-play-requested')) {
          player.setAttribute('autoplay', '');
          player.play().catch(() => {});
        }
      } catch (error) {
        wrapper.removeAttribute('data-loading');
        wrapper.setAttribute('data-mux-error', '');
        console.error('Unable to load Mux Player', error);
      }
    };

    if ('IntersectionObserver' in window) {
      mux.prefetchObserver = mux.prefetchObserver || new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          mux.loadPlayer().catch(() => {});
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '600px 0px' });

      mux.viewportObserver = mux.viewportObserver || new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          activatePlayer(entry.target, false);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px' });
    }

    const initialisePlayers = (root) => {
      root.querySelectorAll(PLAYER_SELECTOR).forEach((wrapper) => {
        if (wrapper.hasAttribute('data-mux-observed')) return;
        wrapper.setAttribute('data-mux-observed', '');

        if (mux.prefetchObserver) {
          mux.prefetchObserver.observe(wrapper);
        } else {
          mux.loadPlayer().catch(() => {});
        }

        if (wrapper.dataset.loadMode === 'viewport') {
          if (mux.viewportObserver) {
            mux.viewportObserver.observe(wrapper);
          } else {
            activatePlayer(wrapper, false);
          }
        }
      });
    };

    initialisePlayers(document);

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-mux-play-button]');
      if (!button) return;
      activatePlayer(button.closest(PLAYER_SELECTOR), true);
    });

    document.addEventListener('shopify:section:load', (event) => {
      initialisePlayers(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll(PLAYER_SELECTOR).forEach((wrapper) => {
        mux.prefetchObserver?.unobserve(wrapper);
        mux.viewportObserver?.unobserve(wrapper);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
